//NOTE autogenerated by export script
export {ActivitiesService as Activities} from './activities.service'
export {AnimalsService as Animals} from './animals.service'
export {CamerasService as Cameras} from './cameras.service'
export {CollarLogsService as CollarLogs} from './collarLogs.service'
export {CollarsService as Collars} from './collars.service'
export {CommandsService as Commands} from './commands.service'
export {ConfigurationDevicesService as ConfigurationDevices} from './configurationDevices.service'
export {DataLoggersService as DataLoggers} from './dataLoggers.service'
export {DropOffsService as DropOffs} from './dropOffs.service'
export {ESRIService as ESRI} from './eSRI.service'
export {ExternalSensorsService as ExternalSensors} from './externalSensors.service'
export {GPSPositionsService as GPSPositions} from './gPSPositions.service'
export {MarkerIconService as MarkerIcon} from './markerIcon.service'
export {MortalitiesService as Mortalities} from './mortalities.service'
export {MortalityImplantsService as MortalityImplants} from './mortalityImplants.service'
export {MovebankService as Movebank} from './movebank.service'
export {NotificationsService as Notifications} from './notifications.service'
export {OldAnimalsService as OldAnimals} from './oldAnimals.service'
export {OldCollarsService as OldCollars} from './oldCollars.service'
export {OldDeploymentsService as OldDeployments} from './oldDeployments.service'
export {PaymentInformationService as PaymentInformation} from './paymentInformation.service'
export {ProximitiesService as Proximities} from './proximities.service'
export {ScheduleTemplatesService as ScheduleTemplates} from './scheduleTemplates.service'
export {SeparationService as Separations} from './separation.service'
export {TT4SensorsService as TT4Sensors} from './tT4Sensors.service'
export {TrapEventsService as TrapEvents} from './trapEvents.service'
export {TrapsService as Traps} from './traps.service'
export {UsersService as Users} from './users.service'
export {VaginalImplantsService as VaginalImplants} from './vaginalImplants.service'
export {VirtualFenceEventsService as VirtualFenceEvents} from './virtualFenceEvents.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {ItemsServices as Items} from './itemsService'
export {EventsServices as Events} from './eventsService'
export {AllServices as All} from './allService'